import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';

const Skeleton = (props: SkeletonProps) => {
  return <MUISkeleton {...props} height={8} sx={{ margin: 5 }} />;
};

export default Skeleton;
